import { CarriersEnum, RatingModeEnum } from '@app/app.enum';
import { IIntlProps } from '@app/models';
import { FormControl, MenuItem, TextField } from '@material-ui/core';
import { FormikProps, FormikValues } from 'formik';
import * as React from 'react';
import { injectIntl } from 'react-intl';

interface IRatingModeComponentProps extends IIntlProps {
	disabled: boolean;
	name: string;
	carrierCode: CarriersEnum;
	formikProps: FormikProps<FormikValues>;
}

const RatingModeComponent: React.FunctionComponent<IRatingModeComponentProps> = ({
	formikProps,
	carrierCode,
	intl,
	disabled,
	name,
}) => {
	return (
		<FormControl fullWidth={true}>
			<TextField
				select={true}
				variant='outlined'
				label={intl.formatMessage({
					id: 'app.carrier-account.config.ratingMode-label',
				})}
				fullWidth={true}
				disabled={disabled}
				InputLabelProps={{ shrink: true }}
				SelectProps={{
					renderValue: (value: string) => {
						return intl.formatMessage({
							id: `app.carrier-account.config.ratingMode-${value}-label`,
						});
					},
				}}
				value={formikProps.values[name]}
				onChange={(e) => formikProps.handleChange(name)(e)}
			>
				<MenuItem value={RatingModeEnum.WithShipment}>
					{intl.formatMessage({
						id: `app.carrier-account.config.ratingMode-${RatingModeEnum.WithShipment}-label`,
					})}
				</MenuItem>
				{(carrierCode === CarriersEnum.USPSeVSNative || carrierCode === CarriersEnum.FedExNative) && (
					<MenuItem value={RatingModeEnum.WithManifest}>
						{intl.formatMessage({
							id: `app.carrier-account.config.ratingMode-${RatingModeEnum.WithManifest}-label`,
						})}
					</MenuItem>
				)}
				<MenuItem value={RatingModeEnum.Disabled}>
					{intl.formatMessage({
						id: `app.carrier-account.config.ratingMode-${RatingModeEnum.Disabled}-label`,
					})}
				</MenuItem>
			</TextField>
		</FormControl>
	);
};

export default injectIntl(RatingModeComponent);



// WEBPACK FOOTER //
// ./src/components/carriers/rating-mode.component.tsx